var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col gap-6 mt-3"},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"With Ref"}},[_c('open-with')],1),_c('vs-tab',{attrs:{"label":"Without Ref"}},[_c('open-without')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }